import styled, { css, keyframes } from 'styled-components';

const slideIn = keyframes`
  100% {
    transform: translateX(0%);
  }
`;

export const Notification = styled.div`
  padding: 10px;
  color: rgba(0,0,0,0.65);
  border-radius: 4px;
  background-color: orange
  animation: ${slideIn} 400ms forwards;
  transform: translateX(200%);
  position: absolute;
  cursor: pointer;
  bottom: 20px;
  right: 20px;
  max-width: 300px;
  ${({ type }) =>
    type === 'ERROR' &&
    css`
      background-color: #fff1f0;
      border: 1px solid #ffa39e;
    `}
  ${({ type }) =>
    type === 'SUCCESS' &&
    css`
      background-color: #f6ffed;
      border: 1px solid #b7eb8f;
    `}
  ${({ type }) =>
    type === 'WARNING' &&
    css`
      background-color: #fffbe6;
      border: 1px solid #ffe58f;
    `}
  ${({ type }) =>
    type === 'INFO' &&
    css`
      background-color: #e6f7ff;
      border: 1px solid #91d5ff;
    `}
    &:hover {
      &:before {
        content: 'Close';
        display: block;
        border-radius: 4px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
`;
